module.exports = __webpack_public_path__ + "static/media/Pentagon.e9ef66e4.svg";